export default {
  startTime: "Start Time",
  endTime: "End Time",
  to: "to",
  confirm: "Confirm to proceed",
  opertion: "Operation?",
  enter: "OK",
  cancel: "Cancel",
  selectAll: "Select All",
  sort: "Serial Number",
  upload:"Upload",
  imgUploading: "Image uploading",
  imgLimit: "Only supports jpg, png, gif format pictures!",
  add:"Add",
  update: "Modify",
  drag: "Drag the file here, or",
  clickUpload: "Click to upload",
  downTemplate:"Download Template",
  submit:"Submit",
  write: "Please fill in",
  validate:"Data validation",
  uploadFail: "Upload failed",
  uploadSuc: "Upload suc",
  uploading: "Uploading...."


};
